"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allTransitionStyles = void 0;
var tslib_1 = require("tslib");
var emotion_1 = require("emotion");
var appStylesBase_1 = require("./appStylesBase");
var allTransitionStyles = function () { return (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  transition: all ", "s ease-in;\n"], ["\n  transition: all ", "s ease-in;\n"])), (0, appStylesBase_1.appStylesBase)().animationSeconds.medium); };
exports.allTransitionStyles = allTransitionStyles;
var templateObject_1;
